// extracted by mini-css-extract-plugin
export var table = "_vs-0";